import {
  SideBarStudentItem,
  StudentSideBarItemType,
} from './componenets/side-bar-student-item';
import React from 'react';
import './componenets/side-bar-lecturer.css';

export interface SideBarLecturerModel {
  onClick: (type: StudentSideBarItemType) => void;
  selectedType?: StudentSideBarItemType;
}

export const SideBarLecturer: React.FC<SideBarLecturerModel> = ({
  onClick,
  selectedType,
}) => {
  return (
    <div className="lecturer-sidebar">
      <div className="sidebar-section">
        <h3 className="section-title">מידע אישי</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.PROFILE}
          text={'פרטים אישיים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.PROFILE}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">לימודים</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.LECTURES}
          text={'מפגשים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.LECTURES}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.LECTURES_CALENDAR}
          text={'מפגשים - קלנדריות'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.LECTURES_CALENDAR}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.EXAMS}
          text={'מבחנים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.EXAMS}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.ASSIGNMENTS}
          text={'מטלות'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.ASSIGNMENTS}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">מידע פיננסי</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.RATES}
          text={'תעריפים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.RATES}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">מסמכים</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.DOCS}
          text={'מסמכים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.DOCS}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">שעות עבודה</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.WORKING_HOURS}
          text={'שעות עבודה'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.WORKING_HOURS}
        />
      </div>
    </div>
  );
};
